export class ProgramRequestSubmission {
    public name: string;
    public email: string;
    public date: Date;
    public phoneNumber: string;
    public comment: string;
    public captchaCode: string;
}


// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/program/program-request-submission.ts